module.exports = __webpack_public_path__ + "img/onboarding.811a9559.svg";